import { Plugin, PluginKey } from "prosemirror-state";
import { Decoration, DecorationSet } from "prosemirror-view";
import extractUrlsWithIndices from "twitter-text/dist/extractUrlsWithIndices";

export const extractLinks = (text, unique = true) =>
  extractUrlsWithIndices(text)
    .map((item) => item.url)
    .filter((value, index, self) => !unique || self.indexOf(value) === index);

const findLinks = (doc) => {
  const decorations = [];

  doc.descendants((node, position) => {
    if (!node.text) {
      return;
    }

    extractUrlsWithIndices(node.text).forEach(({ url, indices }) => {
      const value = url;
      const index = indices[0];
      const from = position + index;
      const to = from + value.length;
      const decoration = Decoration.inline(from, to, {
        nodeName: "span",
        "data-mark": "",
        "data-type": "link",
      });

      decorations.push(decoration);
    });
  });

  return DecorationSet.create(doc, decorations);
};

export const linkHighlighterPluginKey = new PluginKey("link-highlighter");

export const linkHighlighterPlugin = () =>
  new Plugin({
    key: linkHighlighterPluginKey,
    state: {
      init(_, { doc }) {
        return findLinks(doc);
      },
      apply(transaction, oldState) {
        return transaction.docChanged ? findLinks(transaction.doc) : oldState;
      },
    },
    props: {
      decorations(state) {
        return this.getState(state);
      },
    },
  });
